import { EmptyProps } from '@core/components/empty/empty.component';
import { PaymentHistoryData } from '@shared/payment-history/payment-history.component';
import { CurrencyEnum } from 'lingo2-models';

export const emptyTeachingObj: Partial<EmptyProps> = {
  title: 'user-profile.subjects-taught',
  text: 'user-profile.placeholder.teaching.text',
  link: '/profile/teaching',
  link2: '/profile/teaching',
  link_label: 'user-profile.placeholder.about.link',
  image: 'subjects',
};

export const emptyAboutObj: Partial<EmptyProps> = {
  title: 'user-profile.tab-about-tutor',
  text: 'user-profile.placeholder.about.text',
  link: '/profile/about',
  link_auth: true,
  link2: '/profile/about',
  link_label: 'user-profile.placeholder.about.link',
  image: 'about-tutor',
};

export const emptyEducationObj: Partial<EmptyProps> = {
  title: 'user-profile.title-education',
  text: 'user-profile.placeholder.about.text',
  link: '/profile/education',
  link2: '/profile/education',
  link_label: 'user-profile.placeholder.about.link',
  image: 'education',
};

export const emptyExperienceObj: Partial<EmptyProps> = {
  title: 'user-profile.title-experience',
  text: 'user-profile.placeholder.about.text',
  link: '/profile/experience',
  link2: '/profile/experience',
  link_label: 'user-profile.placeholder.about.link',
  image: 'experience',
};

export const emptyClassesObj: Partial<EmptyProps> = {
  title: 'user-profile.tab-classes',
  text: 'user-profile.placeholder.Classes.text',
  link: '/my-library/services',
  link2: '/my-library/services',
  link_label: 'user-profile.placeholder.Classes.link',
  image: 'classes',
};

export const emptyCollectionObj: Partial<EmptyProps> = {
  title: 'user-profile.title-collections',
  text: 'user-profile.placeholder.collection.text',
  link: '/my-library/collections',
  link2: '/my-library/collections',
  link_label: 'user-profile.placeholder.collection.link',
  image: 'collections',
};

export const emptyFeedbackObj: Partial<EmptyProps> = {
  title: 'user-profile.reviews',
  text: 'user-profile.placeholder.feedback.text',
  link: '/my-library/services',
  link2: '/my-library/services',
  link_label: 'user-profile.placeholder.feedback.link',
  image: 'comments',
};

export const emptyLessonObj: Partial<EmptyProps> = {
  title: 'user-profile.tab-lessons',
  text: 'user-profile.placeholder.lesson.text',
  link: '/my-library/lessons',
  link2: '/my-library/lessons',
  link_label: 'user-profile.placeholder.lesson.link',
  image: 'lessons',
};

export const emptySchoolObj: Partial<EmptyProps> = {
  title: 'user-profile.tab-schools',
  text: 'user-profile.placeholder.school.text',
  link: '/schools',
  link2: '/schools',
  link_label: 'user-profile.placeholder.school.link',
  image: 'schools',
};
